import { Injectable } from '@angular/core';

function _window() : any {
   // return the global native browser window object
   return window;
}

@Injectable()
export class WindowRefService {
   get nativeWindow() : any {
      return _window();
   }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/services/WindowRef.service.ts